import "./review-details-mob.component.scoped.sass";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { history } from "react-router-guard";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import { TextField, Button } from "@material-ui/core";
import { icons } from "src/statics/icons";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { ReviewsService } from "src/services/reviews/reviews.service";

export const ReviewDetailsMobComponent = (props: any) => {
  const { taskData, loading, review } = props;
  const { recordTaskId } = taskData;
  const [t] = useTranslation();
  const [rate, setRate]: any = useState(review.rate || 0);
  const [comment, setComment]: any = useState(review.comment || '');
  const [saving, setSaving]: any = useState(false);
  const { createBuildingsIco } = icons;
  const reviewsService = new ReviewsService();

  const fillStars = (newRate: any): any => {
    if (rate === newRate) {
      setRate(0);
    } else {
      setRate(newRate);
    }
  };

  const goBack = () => {
    history.goBack();
  }

  const saveReview = async(): Promise<void> => {
    setSaving(true);
    const review = {
      comment, rating: rate
    }
    await reviewsService.makeReviewForTask(review, recordTaskId);
    setSaving(false);
  };

  const reviewTextChangeHandler = (event: any) => {
    const value = event?.target?.value;
    setComment(value);
  };

  useEffect(() => {
    setComment(review.comment);
    setRate(Math.ceil(review.rate || 0));
  }, [review]);

  return (
    <div className="wrapper">
      {loading && (
        <div className="loader">
          <CircularProgress />
        </div>
      )}
      {!loading && (
        <div className="review-wrapper">
          <div className="rating-text">Bewerten Sie diesen Einsatz</div>
          <div className="rating-stars">
            {Array(rate)
              .fill(0)
              .map((item: any, index: any) => (
                <div className="star" key={index}>
                  <StarIcon onClick={() => fillStars(index + 1)} />
                </div>
              ))}
            {Array(5 - rate)
              .fill(0)
              .map((item: any, index: any) => (
                <div className="empty-star" key={index}>
                  <StarBorderIcon
                    onClick={() => fillStars(rate + index + 1)}
                  />
                </div>
              ))}
          </div>
          <div className="review-text">Notizen</div>
          <div className="review-field">
            <TextField 
              variant="outlined" 
              className="note-textarea" 
              value={comment}  
              placeholder="Fügen Sie Ihrer Bewertung eine Anmerkung hinzu…" 
              multiline 
              fullWidth 
              rows={8} 
              onChange={(event: any) =>
                reviewTextChangeHandler(event)
              }
            />
          </div>
          <div className="review-footer">
            <Button
              variant="contained"
              className="btn-back"
              disabled={saving}
              onClick={goBack}
            >
              <ArrowBackIosIcon style={{ fontSize: "1.5rem" }} />
              {t("back")}
            </Button>
            <Button
              variant="contained"
              disabled={saving}
              className="btn-save"
              onClick={saveReview}
            >
              {!saving && <div className="btn-flex"><img
                alt="icon"
                className="icon icon-refresh"
                src={createBuildingsIco}
              />{t("send")}</div>}
              {saving && <CircularProgress color="primary" />}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
